module.exports = __webpack_public_path__ + "img/logo-color.7c655dc0.png";